import React, { FC } from 'react';
import { useAuthenticationContext } from '@aarhus-university/au-lib-react-components/src/lib/context';
import { useTranslation } from '@aarhus-university/au-lib-react-components/src/lib/hooks';
import LoginComponent from './LoginComponent';
import { defaultLabels, importJson, TranslationsContext } from '../../lib/translation';
import MenuWrapperComponent from './MenuWrapperComponent';
import UserContextBasicComponent from '../../context/UserContextBasicComponent';

const LoginWrapperComponent: FC = () => {
  const authenticated = useAuthenticationContext();
  const lang = window.appLang;
  const translations = useTranslation<IApplicationTranslation>(defaultLabels, [importJson('labels', lang), importJson('generics', lang)], lang);
  if (authenticated) {
    return (
      <TranslationsContext.Provider value={translations}>
        <UserContextBasicComponent>
          <MenuWrapperComponent hasAnswered />
        </UserContextBasicComponent>
      </TranslationsContext.Provider>
    );
  }

  return (
    <TranslationsContext.Provider value={translations}>
      <LoginComponent
        returnUrl={window.location.href.replace(window.location.search, '')}
      />
    </TranslationsContext.Provider>
  );
};

LoginWrapperComponent.displayName = 'LoginWrapperComponent';
export default LoginWrapperComponent;
